<template>
    <v-form
     ref="form-prefetch"
     :disabled="isFetch"
    >
        <v-row>
            <v-col cols="4">
                <v-text-field
                        v-model="search"
                        label="ИНН"
                        :error-messages="errorMessages"
                        required
                ></v-text-field>
            </v-col>
            <v-col cols="2">
                <v-btn
                    color="success"
                    class="mr-4"
                    @click="onSearch"
                >
                    Найти
                </v-btn>
            </v-col>
        </v-row>

    </v-form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "JurPrefetch",
    data(){
        return {
            isFetch: false,
            search: null,
            errorMessages: ''
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_RESPONSE_ERROR']),
        async onSearch(){
            try {
                this.isFetch = true;
                let {data} = await this.getClient().prefetch(this.search);
                this.$emit('result', data);
            }catch (e){
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка поиска ('});
                console.log(e);
            }finally {
                this.isFetch = false;
            }
        }
    },
    computed: {
        ...mapGetters( 'contragents', ['getClient']),
    }
}
</script>

<style scoped>

</style>